import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBusStation = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			fill: "#f5ad00",
			height: 24,
			rx: 12,
			width: 24
		}),
		/* @__PURE__ */ _jsxs("g", {
			stroke: "#fff",
			strokeLinecap: "round",
			strokeWidth: 1.5,
			children: [
				/* @__PURE__ */ _jsx("path", { d: "m6.375 6.9375h11.25" }),
				/* @__PURE__ */ _jsx("path", { d: "m6.375 10.875h11.25" }),
				/* @__PURE__ */ _jsx("path", { d: "m17.625 15.9375h-11.25v-9.375c0-.49728.17779-.97419.49426-1.32583.31646-.35163.74569-.54917 1.19324-.54917h7.875c.4476 0 .8768.19754 1.1932.54917.3165.35164.4943.82855.4943 1.32583z" }),
				/* @__PURE__ */ _jsx("path", { d: "m17.625 15.9375v1.6875c0 .1492-.0593.2923-.1648.3977-.1054.1055-.2485.1648-.3977.1648h-1.6875c-.1492 0-.2923-.0593-.3977-.1648-.1055-.1054-.1648-.2485-.1648-.3977v-1.6875" }),
				/* @__PURE__ */ _jsx("path", { d: "m9.1875 15.9375v1.6875c0 .1492-.05926.2923-.16475.3977-.10549.1055-.24857.1648-.39775.1648h-1.6875c-.14918 0-.29226-.0593-.39775-.1648-.10549-.1054-.16475-.2485-.16475-.3977v-1.6875" })
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m9.46875 14.25c.46599 0 .84375-.3778.84375-.8438 0-.4659-.37776-.8437-.84375-.8437s-.84375.3778-.84375.8437c0 .466.37776.8438.84375.8438z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m14.5312 14.25c.466 0 .8438-.3778.8438-.8438 0-.4659-.3778-.8437-.8438-.8437-.4659 0-.8437.3778-.8437.8437 0 .466.3778.8438.8437.8438z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m19.875 8.625v1.6875",
			stroke: "#fff",
			strokeLinecap: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m4.125 8.625v1.6875",
			stroke: "#fff",
			strokeLinecap: "round",
			strokeWidth: 1.5
		})
	]
});
export default SvgBusStation;
